import React from 'react'
import reqwest from 'reqwest'
import { Card, Table, Pagination, Image } from 'antd'
import moment from 'moment'
import datatable from '../../../utils/tableData'
import ServerApi from '../../../utils/ServerApi';
import appConst from '../../../constents/app.const'
import api_url from '../../../utils/requestApi'

class DepositHistory extends React.Component{
    constructor(props){
        super(props)
        this.tableDataFetch = this.tableDataFetch.bind(this)
    }
    state={
        tableData: [],
        empty: true,
        loading: false,
        current_page: 1,
        page_size: 10,
        total_page: 1
    }
    componentDidMount(){
        this.tableDataFetch()
    }
    tableDataFetch(current_page = this.state.current_page){
        let serverApi = new ServerApi(appConst.apiUrl, this.props.token);
        this.setState({loading: true}, () => {
            serverApi.deposit_history(api_url.deposit_history+current_page+'/'+this.state.page_size, (returnData) => {
                if(returnData.success == '1'){
                    this.setState({
                        empty: false,
                        tableData: this.processData(returnData.data),
                        current_page: returnData.current_page,
                        total_page: returnData.total_page,
                        total_page: returnData.total
                    })
                }else{
                    this.setState({
                        empty: true
                    })
                }
                this.setState({loading: false})
            })
        })
    }
    processData = (response) => {
        response.map((obj, i) => {
            obj.key = i;
            obj.serial = this.state.current_page == 1 ? i+1 : ((this.state.current_page - 1) * this.state.page_size) + i + 1;
            obj.time = obj.time?moment(obj.time).format('LLL'):'';
            // obj.action_time = obj.action_time.replace(' ', '_') 
            obj.action_time = obj.action_time != null?moment(obj.action_time).format('LLL'):'';
            if(obj.depo_img != ''){
                obj.depo_img = <Image preview={true} src={appConst.apiUrl+'/img/deposit/'+obj.depo_img} width={100}/>;
            }else{
                obj.depo_img = '';
            }
            let dep_amount = (obj.amount2==0)?obj.amount:obj.amount2;
            obj.return = obj.rate+'x'+dep_amount+' = '+Number(obj.rate)*Number(dep_amount);
            if(obj.action == 0 && obj.seen == 0){
                obj.status = <span style={{color: '#8B8B05'}}>Pending</span>
            }else if(obj.action == 1 && obj.seen == 0){
                obj.status = <span style={{color: 'orange'}}>Processing</span>
            }else if(obj.action == 3 && obj.seen == 0){
                obj.status = <span style={{color: 'red'}}>Cencelled</span>
            }else if(obj.seen == 1){
                obj.status = <span style={{color: 'green'}}>Confirm</span>
            }
        })
        return response;
    }
    
    render(){
        return(
            <Card>
                <u className="ml-5"><h5>Deposit History</h5></u>
                <div className="table-container">
                    <Table
                        loading={this.state.loading}
                        bordered={true}
                        tableLayout="auto"
                        size="small"
                        dataSource={this.state.tableData}
                        //dataSource={datatablee.deposit}
                        pagination={false}
                        columns={datatable.deposit}
                    />
                    <div style={{marginTop:"10px",float:"right"}}>
                        <Pagination 
                            size="small"
                            defaultCurrent={this.state.current_page}
                            current={this.state.current_page}
                            pageSize={this.state.page_size}
                            total={this.state.total_page}
                            onChange={(page) => {
                                this.setState({current_page: page}, () => {
                                    this.tableDataFetch()
                                })
                            }}
                        />
                    </div>
                </div>
            </Card>
        )
    }
}

export default DepositHistory;